import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NextpageModule } from '../nextpage/nextpage.module';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatGridListModule } from '@angular/material/grid-list';
import { SharedModule } from '../shared/shared.module';
import { WeldingApiModule } from '../shared/welding-api.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MultiSelectFilterComponent } from './filters/multi-select/multi-select-filter/multi-select-filter.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { RangeFilterComponent } from './filters/range-filter/range-filter.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { WeldingSearchComponent } from './pages/welding-search/welding-search.component';
import { CoatingSolutionSearchComponent } from './pages/coating-solution-search/coating-solution-search.component';
import { CoatingApiModule } from '../shared/coating-api.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatChipsModule } from '@angular/material/chips';
import { TextFilterComponent } from './filters/text-filter/text-filter.component';
import { PipingSearchComponent } from './pages/piping-search/piping-search.component';
import { ValvePanelComponent } from '../shared/components/valve-panel/valve-panel.component';
import { PipingAdminSearchComponent } from './pages/piping-admin-search/piping-admin-search.component';
import { ValveSummaryPageComponent } from './valve-summary-page/valve-summary-page.component';
import { PipingTabsParentComponent } from './piping-tabs-parent/piping-tabs-parent.component';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PipingComponentsComponent } from './piping-components/piping-components.component';
import { PipeComponentDetailsComponent } from './piping-components/pipe-component-details/pipe-component-details.component';
import { ValveTabComponent } from './valve-tab/valve-tab.component';
import { PipingNotesComponent } from './piping-notes/piping-notes.component';
import { PressureTempTableComponent } from '../piping-valves/pressure-temp-table/pressure-temp-table.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { PipingSummaryComponent } from './piping-summary/piping-summary.component';
import { MatCardModule } from '@angular/material/card';
import { ServiceSelectionModalComponent } from './piping-summary/service-selection-modal/service-selection-modal.component';
import { PropertySelectionModalComponent } from './piping-summary/property-selection-modal/property-selection-modal.component';
import { GeneralDetailsComponent } from './general-details/general-details.component';
import { CommentsSectionComponent } from './piping-summary/comments-section/comments-section.component';
import { ComponentCatalogModalComponent } from './piping-summary/component-catalog-modal/component-catalog-modal.component';
import { ValveCatalogModalComponent } from './piping-summary/valve-catalog-modal/valve-catalog-modal.component';
import { PTTSyncService } from './services/ptt-sync.service';
import { ValveSelectionModalComponent } from './valve-selection-modal/valve-selection-modal.component';
import { BranchTablesComponent } from './branch-tables/branch-tables.component';
import { BranchDictionaryModalComponent } from './branch-tables/branch-dictionary-modal/branch-dictionary-modal.component';
import { BranchComponent } from '../admintool/piping/dictionaries/branch/branch.component';
import { BranchTableSelectorModalComponent } from '../admintool/piping/dictionaries/branch/branch-table-selector-modal/branch-table-selector-modal.component';
import { BranchPreviewComponent } from '../admintool/piping/dictionaries/dialogs/branch-preview/branch-preview.component';
import { ServiceNoteUsageComponent } from '../admintool/piping/dictionaries/dialogs/service-note-usage/service-note-usage.component';
import { DictionaryDeleteComponent } from '../admintool/piping/dictionaries/dialogs/dictionary-delete/dictionary-delete.component';
import { CommonNoteSelectorModalComponent } from '../admintool/piping/dictionaries/branch/common-note-selector-modal/common-note-selector-modal.component';
import { BranchTableNoteModalComponent } from './branch-tables/branch-table-note-modal/branch-table-note-modal.component';
import { CloneValveButtonComponent } from '../shared/components/buttons/clone-valve/clone-valve.component';
import { ValveSpecModalComponent } from './valve-spec-modal/valve-spec-modal.component';
import { ValveEditPageComponent } from './valve-edit-page/valve-edit-page.component';
import { ValveBulkUploadComponent } from './valve-bulk-upload/valve-bulk-upload.component';
import { ValveSizeDisplayPipe } from '../revisions/pipes/valve-size-display.pipe';
import { RemoveCharactersPipe } from '../revisions/pipes/remove-characters.pipe';
import { ClonePipeClassDialogComponent } from './clone-pipe-class-dialog/clone-pipe-class-dialog.component';
import { RetirePipeClassDialogComponent } from './retire-pipe-class-dialog/retire-pipe-class-dialog.component';

@NgModule({
  declarations: [
    MultiSelectFilterComponent,
    RangeFilterComponent,
    TextFilterComponent,
    WeldingSearchComponent,
    CoatingSolutionSearchComponent,
    PipingSearchComponent,
    PipingAdminSearchComponent,
    ValvePanelComponent,
    CloneValveButtonComponent,
    ValveSpecModalComponent,
    ValveEditPageComponent,
    ValveBulkUploadComponent,
    ValveTabComponent,
    ValveSummaryPageComponent,
    PipingTabsParentComponent,
    PipingComponentsComponent,
    PipeComponentDetailsComponent,
    PipingNotesComponent,
    PressureTempTableComponent,
    PipingSummaryComponent,
    ServiceSelectionModalComponent,
    PropertySelectionModalComponent,
    GeneralDetailsComponent,
    ComponentCatalogModalComponent,
    CommentsSectionComponent,
    ValveCatalogModalComponent,
    ValveSelectionModalComponent,
    BranchTablesComponent,
    BranchDictionaryModalComponent,
    BranchComponent,
    BranchTableSelectorModalComponent,
    BranchPreviewComponent,
    ServiceNoteUsageComponent,
    DictionaryDeleteComponent,
    CommonNoteSelectorModalComponent,
    BranchTableNoteModalComponent,
    ValveSizeDisplayPipe,
    RemoveCharactersPipe,
    ClonePipeClassDialogComponent,
    RetirePipeClassDialogComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NextpageModule,
    MatSortModule,
    MatTableModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    MatSelectModule,
    MatAutocompleteModule,
    BrowserAnimationsModule,
    MatGridListModule,
    SharedModule,
    WeldingApiModule,
    CoatingApiModule,
    MatDialogModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatRadioModule,
    NgxSliderModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatSnackBarModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
    MatChipsModule,
    MatTabGroup,
    MatTab,
    MatCardModule,
    DragDropModule,
    MatTooltipModule
  ],
  exports: [
    MultiSelectFilterComponent,
    PipingTabsParentComponent
  ],
  providers: [
    PTTSyncService
  ],
})
export class SearchModule {}
